import React from 'react';
import { Trans } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';
import { View } from '@actual-app/components/view';

import type { CategoryRuleSuggestion } from '#banksync/ai-rules';

type Props = {
  item: CategoryRuleSuggestion;
  onAccept: () => void;
  onDismiss: () => void;
};

export function AiRuleSuggestionsCategoryRow({
  item,
  onAccept,
  onDismiss,
}: Props) {
  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        padding: '6px 8px',
        flexShrink: 0,
        borderBottom: '1px solid ' + theme.tableBorder,
        flexWrap: 'wrap',
      }}
    >
      {/* payee -> category with support count */}
      <View
        style={{
          flex: 1,
          minWidth: 0,
          flexDirection: 'row',
          alignItems: 'center',
          gap: 6,
        }}
      >
        <Text
          style={{
            fontSize: 13,
            color: theme.tableText,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {item.payeeName}
        </Text>
        <Text
          style={{ fontSize: 12, color: theme.pageTextSubdued, flexShrink: 0 }}
        >
          →
        </Text>
        <Text
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: theme.tableText,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {item.categoryName}
        </Text>
        <Text
          style={{ fontSize: 11, color: theme.pageTextSubdued, flexShrink: 0 }}
        >
          ({item.support}/{item.total})
        </Text>
      </View>

      <Button variant="bare" onPress={onAccept} style={{ flexShrink: 0 }}>
        <Trans>Accept</Trans>
      </Button>
      <Button
        variant="bare"
        onPress={onDismiss}
        style={{ flexShrink: 0, color: theme.pageTextSubdued }}
      >
        <Trans>Dismiss</Trans>
      </Button>
    </View>
  );
}
